module.exports = __webpack_public_path__ + "static/media/DotYellow.644032a1.svg";